import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

interface ContainerProps {
  children: React.ReactNode;
}

function GenericFormContainer({children}: ContainerProps){
    return (
        <> 
            <Container>
                <Container fluid className="bg-white py-2">
                    <Row className="py-0">
                        <Col xs={{span: 4, offset: 4}}>
                            <img className="p-0 square-image-block" src="/logo192.png" />
                        </Col>
                    </Row>

                    <Container className="border my-0 py-2">

                        {children}

                    </Container>

                    <Row className="my-2">
                        <p className="py-0 my-0 text-font-body text-font-size-tiny text-font-medium">Sunset Liquor LLC &copy; All Rights Reserved</p>
                        <a href="/privacy" className="py-0 my-0 text-font-body text-font-size-tiny text-font-medium">Information Privacy Policy</a>
                    </Row>
                </Container>
            </Container>
        </>
    )
}

export default GenericFormContainer;